<!-- pantalla de carga durante inicialización de componentes -->
<div class="loading" *ngIf="!loaded"></div>
<div *ngIf="loaded">
  <app-toast-panel></app-toast-panel>
  <div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <app-back-to-top [animated]="true"></app-back-to-top>
    <app-loading [hidden]="!loadingService.isLoading()"></app-loading>
  </div>
</div>